/**
 * View Participants Modal
 * ======================
 * 
 * Modal for viewing all participants in an inbox conversation.
 */

import React from 'react';
import './ViewParticipantsModal.scss';

interface Participant {
  user_id: string;
  name: string;
  email: string;
}

interface ViewParticipantsModalProps {
  isOpen: boolean;
  onClose: () => void;
  participants: Participant[];
  onAddParticipant?: () => void;
}

const ViewParticipantsModal: React.FC<ViewParticipantsModalProps> = ({
  isOpen,
  onClose,
  participants,
  onAddParticipant
}) => {
  if (!isOpen) return null;

  return (
    <div className="view-participants-modal-overlay" onClick={onClose}>
      <div className="view-participants-modal" onClick={(e) => e.stopPropagation()}>
        <div className="view-participants-modal__header">
          <h2>Participants</h2>
          <button className="view-participants-modal__close" onClick={onClose}>×</button>
        </div>
        <div className="view-participants-modal__content">
          {participants.length === 0 ? (
            <div className="view-participants-modal__empty">
              No participants found.
            </div>
          ) : (
            <div className="view-participants-modal__list">
              {participants.map((participant) => (
                <div key={participant.user_id} className="view-participants-modal__item">
                  <div className="view-participants-modal__avatar">
                        {participant.name.charAt(0).toUpperCase()}
                      </div>
                  <div className="view-participants-modal__info">
                    <div className="view-participants-modal__name">{participant.name}</div>
                    <div className="view-participants-modal__email">{participant.email}</div>
                  </div>
                </div>
              ))}
              {onAddParticipant && (
                <div 
                  className="view-participants-modal__item view-participants-modal__item--add"
                  onClick={() => {
                    onAddParticipant();
                    onClose();
                  }}
                >
                  <div className="view-participants-modal__avatar view-participants-modal__avatar--add">
                    +
                  </div>
                  <div className="view-participants-modal__info">
                    <div className="view-participants-modal__name">Add</div>
                    <div className="view-participants-modal__email">Add new participant</div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="view-participants-modal__footer">
          <button
            className="view-participants-modal__close-btn"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewParticipantsModal;

